import React, { useContext } from 'react';
import Footer from './Footer';
import img from "./img/123.png";
import CardData from './context/Context';
import { CardContext } from './context/CardContext';
import Button from '@material-ui/core/Button';
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";




const Home = () => {
    const [value] = React.useState(4);

    const { items } = useContext(CardData);
    const { dispatch } = useContext(CardContext);


    return (
        <>
            <div className="container-fluid ">
                <div className="row">
                    <div className="col-md-6 max-auto sub_div1 ">
                        <h6 className="mt-3">Are you hungry?</h6>
                        <h1 className="my-4">Dont'wait !!</h1>
                        <Button className=" OrderNow mt-3 py-3 px-5" variant="contained" style={{ backgroundColor: "#28B463", color: "white" }}> Order Now</Button>
                    </div>
                    <div className="col-md-12 max-auto ">
                        <img className=" header_img" src="https://mdbootstrap.com/img/Photos/Others/food3.jpg"
                            alt="Sample" />
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className='col-12 max-auto mt-5 mb-3 text-center'>
                        <h1 className="heading2 ">Our Products </h1>
                        <hr className="w-25 m-auto" />
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="cards">
                    {
                        items.map((product) => {
                            return <>
                                <div className="card  text-center" >
                                    <img className="img" src={product.src} alt="" />
                                    <div className="card-body ">
                                        <h5 className="cardTitle text-center">{product.cardTitle}</h5>
                                        <p className="cardText text-center">{product.cardText}</p>
                                        <div className="text-center ">
                                            <Box
                                                sx={{
                                                    "& > legend": { mt: 2 }
                                                }}
                                            >

                                                <Rating name="read-only" value={value} readOnly />
                                            </Box>
                                            <p className="text-bold" > {product.price} ₹</p>
                                            <Button className="py-2 pl-5 px-5 AddButton" variant="contained" style={{ backgroundColor: "#28B463", color: "white" }} onClick={() => dispatch({ type: "ADD_TO_CART", id: product._id, product, })} > <i className="fas fa-shopping-cart px-2 "></i> Add</Button>
                                        </div>
                                    </div>
                                </div>
                            </>;
                        })
                    }
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Home;
